if (!customElements.get('atelier-duck-price')) {
  customElements.define('atelier-duck-price', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.prices = JSON.parse(this.querySelector('script').textContent);
      this.form = document.getElementById(this.dataset.formId);
      if (!this.form) return;
      this.button = this.form.querySelector('[data-product-add-to-cart-button]');
      this.onVariant = event => { const variant = event.detail.variant; if (variant && variant.available) queueMicrotask(() => this.update(variant.id)); };
      this.form.addEventListener('variant:changed', this.onVariant);
      this.update(this.form.querySelector('[name="id"]').value);
    }
    update(id) {
      if (!this.button || this.button.disabled || !this.prices[id]) return;
      const label = this.dataset.label;
      this.button.dataset.buttonContent = label;
      const target = this.button.querySelector('.loader-button__text') || this.button;
      target.textContent = label;
    }
    disconnectedCallback() {
      if (this.form) this.form.removeEventListener('variant:changed', this.onVariant);
      this.ready = false;
    }
  });
}

if (!customElements.get('atelier-duck-delivery')) {
 customElements.define('atelier-duck-delivery',class extends HTMLElement {
  connectedCallback() {
   const arrival = new Date();
   arrival.setDate(arrival.getDate() + (this.dataset.deliveryDays === '28' ? 28 : 7));
   const time = this.querySelector('time');
   if (time) {
    time.dateTime = arrival.getFullYear() + '-' + String(arrival.getMonth()+1).padStart(2,'0') + '-' + String(arrival.getDate()).padStart(2,'0');
    time.textContent = new Intl.DateTimeFormat(this.dataset.locale || 'en',{month:'long',day:'numeric',year:'numeric'}).format(arrival);
   }
   const controller = new AbortController(), timer = setTimeout(() => controller.abort(),5000);
   fetch((window.Shopify?.routes?.root || '/')+'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false',{credentials:'same-origin',signal:controller.signal})
    .then(r=>r.ok?r.json():null).then(data=>{
     const country=data?.detected_values?.country;
     if(this.isConnected && country && typeof country.name==='string' && /^[A-Z]{2}$/.test(country.handle || '')) this.querySelector('[data-delivery-country]').textContent=this.dataset.countryLabel.replace('[country]',country.name);
    }).catch(()=>{}).finally(()=>clearTimeout(timer));
  }
 });
}
